import { createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, vModelText as _vModelText, withDirectives as _withDirectives, resolveDirective as _resolveDirective, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/ics_close.svg'
import _imports_1 from '@/app/ui/assets/svg/exclamation-triangle-red.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-ef627642")

_pushScopeId("data-v-ef627642")
const _hoisted_1 = { class: "flex flex-col gap-2" }
const _hoisted_2 = { class: "flex flex-row items-center justify-between h-8" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "text-sm font-semibold text-gray-lp-300" }, "Wilayah", -1)
const _hoisted_4 = { class: "text-xs text-gray-lp-600" }
const _hoisted_5 = { class: "flex-1 w-full text-sm font-medium text-gray-lp-300" }
const _hoisted_6 = { class: "flex flex-row gap-3 flex-wrap" }
const _hoisted_7 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  alt: "close"
}, null, -1)
const _hoisted_8 = {
  key: 1,
  class: "text-sm text-gray-lp-600"
}
const _hoisted_9 = { class: "w-4 h-4 flex flex-row items-center justify-center" }
const _hoisted_10 = { class: "max-h-72 overflow-y-auto" }
const _hoisted_11 = {
  key: 0,
  class: "px-4"
}
const _hoisted_12 = {
  key: 0,
  class: "flex flex-row gap-0.5 items-center"
}
const _hoisted_13 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  alt: "warning"
}, null, -1)
const _hoisted_14 = { class: "text-red-lp-1200 text-sm" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Icons = _resolveComponent("Icons")!
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_Tree = _resolveComponent("Tree")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode("div", _hoisted_4, _toDisplayString(_ctx.shipmentType), 1)
    ]),
    _withDirectives(_createVNode("div", {
      class: "flex flex-col relative",
      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.openSelect && _ctx.openSelect(...args)))
    }, [
      _createVNode("div", {
        class: ["flex flex-row items-center px-4 py-2.5 border gap-3 cursor-pointer", [
          {'border-gray-lp-400': !_ctx.isError},
          {'border-red-lp-750': _ctx.isError},
          {'border-b-0 rounded-t-md': _ctx.isOpenSelect},
          {'rounded-md': !_ctx.isOpenSelect}
        ]]
      }, [
        _createVNode("div", _hoisted_5, [
          _createVNode("div", _hoisted_6, [
            (_ctx.mapNames().length)
              ? (_openBlock(true), _createBlock(_Fragment, { key: 0 }, _renderList(_ctx.mapNames(), (selected) => {
                  return (_openBlock(), _createBlock("div", {
                    key: selected.name,
                    class: "chip"
                  }, [
                    _createTextVNode(_toDisplayString(selected.name) + " ", 1),
                    _createVNode("button", {
                      onClick: (event) => _ctx.deletedSelected(event, selected)
                    }, [
                      _hoisted_7
                    ], 8, ["onClick"])
                  ]))
                }), 128))
              : (_openBlock(), _createBlock("div", _hoisted_8, "Cari kota atau wilayah"))
          ])
        ]),
        _createVNode("div", _hoisted_9, [
          _createVNode(_component_Icons, {
            name: "chevron-right-thin",
            style: {"width":"6px"},
            class: ["text-gray-lp-600 transform", [
              {'rotate-90': !_ctx.isOpenSelect},
              {'-rotate-90': _ctx.isOpenSelect},
            ]]
          }, null, 8, ["class"])
        ])
      ], 2),
      (_ctx.isOpenSelect)
        ? (_openBlock(), _createBlock("div", {
            key: 0,
            class: ["absolute flex flex-col bg-white w-full z-50 p-1 border border-t-0 rounded-b-md shadow-xl top-full", [
          {'border-gray-lp-400': !_ctx.isError},
          {'border-red-lp-750': _ctx.isError}
        ]]
          }, [
            _withDirectives(_createVNode("input", {
              class: "outline-none w-full px-4",
              type: "text",
              placeholder: "Search",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.keyword = $event))
            }, null, 512), [
              [_vModelText, _ctx.keyword]
            ]),
            _createVNode("div", _hoisted_10, [
              (_ctx.loading)
                ? (_openBlock(), _createBlock("ul", _hoisted_11, [
                    (_openBlock(), _createBlock(_Fragment, null, _renderList(20, (_skel, index) => {
                      return _createVNode("li", {
                        key: index,
                        class: "flex px-2 py-2 items-center select-none gap-4"
                      }, [
                        _createVNode(_component_Skeleton, { height: "28.8px" })
                      ])
                    }), 64))
                  ]))
                : (_openBlock(true), _createBlock(_Fragment, { key: 1 }, _renderList(_ctx.filteredOptions, (option) => {
                    return (_openBlock(), _createBlock(_component_Tree, {
                      key: option.name,
                      geoAddress: option,
                      modelValue: _ctx.model,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.model = $event))
                    }, null, 8, ["geoAddress", "modelValue"]))
                  }), 128))
            ])
          ], 2))
        : _createCommentVNode("", true)
    ], 512), [
      [_directive_click_outside, () => _ctx.closeSelect()]
    ]),
    (_ctx.errorMessage)
      ? (_openBlock(), _createBlock("div", _hoisted_12, [
          _hoisted_13,
          _createVNode("div", _hoisted_14, _toDisplayString(_ctx.errorMessage), 1)
        ]))
      : _createCommentVNode("", true)
  ]))
})